import { ziggyGetRoute as getRoute } from '@/router/ziggyGetRoute';
import { TwoFactorRoutes } from '@/repository/auth';
const { Enable, Disable, SubmitChallenge, ShowQrCode, GetRecoveryCodes, UpdateRecoveryCodes } = TwoFactorRoutes;

export default {
	namespaced: true,
	actions: {
		async store({ }) {
			try {
				let res = await Enable()
				this.commit('auth/user/SET_CURRENT_USER', { two_factor_enabled : true })
				return res
			}
			catch (error) {
				console.error('Could not enable 2FA.', error);
				throw error;
			}
		},
		async destroy({ }) {
			try {
				let res = await Disable()
				this.commit('auth/user/SET_CURRENT_USER', { two_factor_enabled : false })
				return res
			}
			catch (error) {
				console.error('Could not disable 2FA.', error);
				throw error;
			}
		},
		async storeChallenge({ }, data) {
			try {
				return await SubmitChallenge(data)
			}
			catch (error) {
				console.error('Could not submit 2FA Challenge Code.', error);
				throw error;
			}
		},
		async showQrCode({ }) {
			try {
				return await ShowQrCode()
			}
			catch (error) {
				console.error('Could not get 2FA QR Code.', error);
				throw error;
			}
		},
		async indexRecoveryCodes({ }) {
			try {
				return await GetRecoveryCodes()
			}
			catch (error) {
				console.error('Could not get 2FA Recovery Codes.', error);
				throw error;
			}
		},
		async updateRecoveryCodes({ }) {
			try {
				return await UpdateRecoveryCodes()
			}
			catch (error) {
				console.error('Could not update 2FA Recovery Codes.', error);
				throw error;
			}
		}
	}
}